import React from 'react'
import { Link } from 'react-router-dom'
import config from '../../config/config'
import { slugify } from '../../utils/utils'
import { getTranslatedLabel } from '../../utils/getTranslations'
import { useLanguage } from '../../contexts/LanguageContext'
import { PRODUCT_PATH } from '../../config/routes'

const ProductThumbnail = ({ product }) => {
  const { activeLanguage } = useLanguage()
  const label = getTranslatedLabel(product, activeLanguage)
  const imageUrl = `${config.photoUrlMedium}${product.mainPhotoId}.jpg`
  const productUrl = PRODUCT_PATH.replace(':slug', slugify(label)).replace(
    ':id',
    product.id,
  )

  return (
    <Link
      to={productUrl}
      className="card-hover text-decoration-none text-dark w-100"
    >
      <img src={imageUrl} alt={label} className="img-fluid" />
      <div className="card-body text-center">
        <h3>{label}</h3>
      </div>
    </Link>
  )
}

export default ProductThumbnail
